import React from 'react'
import {useSelector} from 'react-redux'
import AuthenticatedEmployee from './EmployeeRoutes'
import AuthenticatedEmployer from './EmployerRoutes'
import {IRootState} from '../State/Store'

const Authenticated: React.FC = () => {
    const user = useSelector((state: IRootState) => state.user)
    return (
            <React.Fragment>
                {user.type === 'ER' ? <AuthenticatedEmployer/> : <AuthenticatedEmployee/>}
            </React.Fragment>
    )
}
export default Authenticated